import 'css-chunksrc/client/scenes/moveElement/list/styles.scss';export default {
  "list": "_list_elryj_1"
};